import { useAuth, usePost } from "@onefront/react-sdk";
import { buildHeaders } from "./buildHeaders";
import React from "react";
import { useClientInformationStore } from "../../store/useClientInformationStore";

export function useCreateFolder({
  folderName,
  referenceIds,
  classification,
  referencePeriod,
}: any) {
  const authData = useAuth();

  const { workspaceId, selectedTenant } = useClientInformationStore();

  const payload = {
    workspaceId,
    folderName,
    classification,
    referencePeriod,
    referenceIds,
    itemClassifier: selectedTenant?.type,
    createdBy: "f.silvestri@teamsystem.com",
  };

  const { data, loading, hasLoaded, fetch, error } = usePost(
    `documentsApi://api/v1/folders`,
    payload,
    {
      lazy: true,
      headers: buildHeaders({ authData }),
    }
  );

  return { data, loading, hasLoaded, fetch, error };
}
